import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { AppointmentsTableComponent } from '../../components/appointments-table/appointments-table.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DataService } from '../../services/data.service';
import { FormControl, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { subYears, addYears } from 'date-fns';
import { AppointmentsPayload } from '../../interfaces/appointments-payload.interface';

@Component({
  selector: 'app-medical-consultations-appointments',
  imports: [NzGridModule, AppointmentsTableComponent, NzInputModule, NzDatePickerModule, NzSelectModule, NzButtonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './medical-consultations-appointments.component.html',
  styleUrl: './medical-consultations-appointments.component.scss',
})
export class MedicalConsultationsAppointmentsComponent {
  appointments: any;
  appointmentsText: any;
  columns: any;
  innerSelectData: any[] = [];

  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private http: HttpService
  ) {
    this.translateService.onLangChange.subscribe((_: LangChangeEvent) => {
      this.getTexts();
    });
    this.getTexts();
  }

  ngOnInit() {
    this.dataService.getAppointments().subscribe((res) => {
      if (res) {
        this.appointments = res;
      } else {
        const userData = JSON.parse(localStorage.getItem('userData')!);
        const today = new Date();
        const payload: AppointmentsPayload = {
          individualId: userData.individualId,
          consultType: 4,
          pageIndex: 1,
          pageSize: 25,
          fromDate: this.formatDate(subYears(today, 1)),
          toDate: this.formatDate(addYears(today, 1)),
          language: this.translateService.currentLang,
        };
        this.http.getAppointments(payload).subscribe((res) => {
          if (res.lista?.length > 0) {
            res.lista = res.lista.map((element: any) => {
              const [date, time] = element.consultDate.split(' ');
              return {
                ...element,
                time,
                consultDate: date,
                statusText: 'statusTable.' + element.status?.toLowerCase(),
              };
            });
            this.appointments = res.lista;
            this.dataService.setAppointments(this.appointments);
          }
        });
      }
    });
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}${month}${day}`;
  }

  private getTexts() {
    this.translateService.get('medicalConsultationsAppointments.appointmentsText').subscribe((appointmentsText: any): void => {
      this.appointmentsText = appointmentsText;
      this.columns = appointmentsText.columns;
    });
    this.getInnerSelectData();
  }

  private getInnerSelectData() {
    this.translateService.get('personalArea.paymentMethods').subscribe((texts) => {
      texts?.innerSelectData?.forEach((text: any) => {
        const innerSelectData = {
          placeholder: text.placeholder,
          label: text.label,
          texts: text.texts,
          elements: text.elements,
          control: new FormControl(null, [Validators.required]),
        };
        this.innerSelectData.push(innerSelectData);
      });
    });
  }
}
